import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ConsoleLoginPage() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post(`${API}/console/login`, { email, password });
            localStorage.setItem('console-token', res.data.access_token);
            localStorage.setItem('console-name', res.data.name);
            toast.success('Connexion console réussie');
            navigate('/console');
        } catch (err) {
            toast.error(err.response?.data?.detail || 'Identifiants incorrects');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
            <div className="bg-white p-8 rounded-xl border border-slate-200 shadow-lg w-full max-w-md" data-testid="console-login-page">
                <div className="flex items-center gap-3 mb-2">
                    <div>
                        <h1 className="text-xl font-bold text-slate-900">Console Centrale CIVIS+</h1>
                        <p className="text-xs text-slate-500">Supervision multi-communes — accès réservé</p>
                    </div>
                </div>
                <form onSubmit={handleSubmit} className="space-y-4 mt-6">
                    <div>
                        <Label className="text-slate-700 text-sm">Email</Label>
                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white border-slate-300 text-slate-900" required data-testid="console-email-input" />
                    </div>
                    <div>
                        <Label className="text-slate-700 text-sm">Mot de passe</Label>
                        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white border-slate-300 text-slate-900" required data-testid="console-password-input" />
                    </div>
                    <Button type="submit" disabled={loading} className="w-full bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="console-login-btn">
                        <Lock className="w-4 h-4 mr-2" /> {loading ? 'Connexion...' : 'Accéder à la console'}
                    </Button>
                </form>
            </div>
        </div>
    );
}
